// The old email pages' addresses (Session AUB): each now lands on the matching tab of the Mail workspace, so a bookmark, a
// link in an email or an old notification keeps working. The detail pages (/office/email-engine/:id and
// /office/enquiries/:id) are NOT redirected: they stay the full record pages the review card links to.
import { Navigate, useSearchParams } from "react-router-dom";

/** Where an old /office/email-engine address lands, its ?tab= and ?filter= carried across. Pure. */
export function emailEngineRedirectTarget(search: URLSearchParams): string {
  const tab = search.get("tab");
  if (tab === "library" || tab === "quality" || tab === "history") return `/office/mail?tab=${tab}`;
  switch (search.get("filter")) {
    case "drafted":
      return "/office/mail?tab=reply";
    case "needs_you":
      return "/office/mail?tab=person";
    case "filed":
      return "/office/mail?tab=filed";
    case "work":
      return "/office/mail?tab=work";
    case "overdue":
      return "/office/mail?tab=all&outcome=pending";
    case "no_reply_needed":
      return "/office/mail?tab=all&outcome=no_reply_needed";
    default:
      return "/office/mail?tab=all";
  }
}

export function EmailEngineRedirect() {
  const [params] = useSearchParams();
  return <Navigate to={emailEngineRedirectTarget(params)} replace />;
}
